/**
 * Variant Picker JS
 * Handles the variant selection functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize variant selectors
  initVariantSelectors();
});

function initVariantSelectors() {
  // Get all variant selectors on the page
  const variantSelectors = document.querySelectorAll('.variant-selectors');
  
  if (!variantSelectors.length) return;
  
  variantSelectors.forEach(selector => {
    // Get all radio buttons and select elements in this selector
    const radioButtons = selector.querySelectorAll('input[type="radio"]');
    const selectElements = selector.querySelectorAll('select');
    
    // Add event listeners to radio buttons
    radioButtons.forEach(radio => {
      radio.addEventListener('change', function() {
        // When a radio button is selected, update the corresponding select element
        const optionName = this.name;
        const optionValue = this.value;
        
        // Find the select element for this option
        const select = Array.from(selectElements).find(select => 
          select.name === `options[${optionName}]` || 
          select.name === `mobile-options[${optionName}]`
        );
        
        if (select) {
          // Update the select element value
          select.value = optionValue;
          
          // Trigger change event on select to update the product variant
          const event = new Event('change', { bubbles: true });
          select.dispatchEvent(event);
        }
      });
    });
    
    // Add event listeners to select elements
    selectElements.forEach(select => {
      select.addEventListener('change', function() {
        // When a select element is changed, update the corresponding radio buttons
        const optionName = this.name.replace('options[', '').replace('mobile-options[', '').replace(']', '');
        const optionValue = this.value;
        
        // Find the radio button for this option
        const radio = Array.from(radioButtons).find(radio => 
          radio.name === optionName && 
          radio.value === optionValue
        );
        
        if (radio) {
          // Update the radio button
          radio.checked = true;
        }
      });
    });
  });
}
